'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('digital-signage', {
      url: '/digital-signage',
      template: '<digital-signage></digital-signage>'
    });
}



// WEBPACK FOOTER //
// ./client/app/digital-signage/digital-signage.routes.js